import { inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE } from './browser-globals';

/**
 * localStorage behind the LOCAL_STORAGE token. On the server every read
 * returns null (SSR renders public pages anonymously); writes are no-ops.
 */
@Injectable({ providedIn: 'root' })
export class BrowserStorageService {
  private storage = inject(LOCAL_STORAGE, { optional: true });

  get(key: string): string | null {
    return this.storage?.getItem(key) ?? null;
  }

  set(key: string, value: string): void {
    this.storage?.setItem(key, value);
  }

  remove(key: string): void {
    this.storage?.removeItem(key);
  }

  clear(): void {
    this.storage?.clear();
  }

  getJson<T>(key: string): T | null {
    const raw = this.get(key);
    try {
      return raw ? (JSON.parse(raw) as T) : null;
    } catch {
      return null;
    }
  }
}
